import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const hasBackend = Boolean(BASE);
export const TOKEN_KEY = "be_admin_token";

export const api = axios.create({ baseURL: BASE ? `${BASE}/api` : undefined, timeout: 15000 });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return d?.msg || String(d);
}
